import { Navigate, Route, Routes, Outlet, useLocation, useOutletContext } from 'react-router-dom';
import AnalyticsLayout from '../layouts/AnalyticsLayout.jsx';
import CohortHomePage from '../modules/cohort/index.js';
import LeadsPivotPage from '../modules/cohort/pages/LeadsPivotPage.jsx';
import InstagramKeywordsPage from '../modules/instagram-keywords/index.js';
import AnaActivityPage from '../modules/ana-activity/index.js';
import AnaChannelsPage from '../pages/AnaChannelsPage.jsx';
import ResumenEjecutivoPage from '../modules/resumen-ejecutivo/index.js';
import {
  LeadsLayout,
  LeadsResumenPage,
  LeadsCalidadPage,
  LeadsEmbudoPage,
  LeadsConversionPage,
  LeadsTendenciasPage,
  LeadsDistribucionPage,
  LeadsInventarioPage,
  LeadsRecuperarCampanaPage
} from '../modules/leads/index.js';
import ComercialPage from '../modules/comercial/index.js';
import MarketingPage from '../modules/marketing/index.js';
import ProyectosPage from '../modules/proyectos/index.js';
import ReunionesPage from '../modules/reuniones/index.js';
import ReservasPage from '../modules/reservas/index.js';
import EjecutivosPage from '../modules/ejecutivos/index.js';
import ConfigPage from '../modules/configuracion/index.js';
import MeetingStagesPage from '../modules/mapeo-reunion/index.js';
import {
  LabAtencionPage,
  LabTrackerPage,
  LabMetasPage,
  LabDefinicionesPage
} from '../modules/lab/index.js';
import NotFoundPage from '../shared/components/NotFoundPage.jsx';
import LeadsTracePage from '../modules/leads/pages/LeadsTracePage.jsx';

function ResumenRoute() {
  const { email } = useOutletContext();
  return <ResumenEjecutivoPage email={email} />;
}

function LeadsRoute() {
  const { email } = useOutletContext();
  return <LeadsLayout email={email} />;
}

function CohortRoute() {
  const { email } = useOutletContext();
  return <CohortHomePage email={email} />;
}

function LabSection() {
  return <Outlet />;
}

function LegacyLeadsRedirect() {
  const { pathname } = useLocation();
  const rest = pathname.replace(/^\/leads/, '') || '';
  if (rest === '/recuperar-campana') return <Navigate to="/fugas-meta" replace />;
  return <Navigate to={'/old/leads' + rest} replace />;
}

export function AppRoutes({ email }) {
  return (
    <Routes>
      <Route element={<AnalyticsLayout email={email} />}>
        <Route index element={<LeadsPivotPage />} />
        <Route path="cohorte-detalle" element={<CohortRoute />} />
        <Route path="meta" element={<MarketingPage />} />
        <Route path="marketing" element={<Navigate to="/meta" replace />} />
        <Route path="ana-actividad" element={<AnaActivityPage />} />
        <Route path="ana-actividad/:channel" element={<AnaActivityPage />} />
        <Route path="ana-canales" element={<AnaChannelsPage />} />
        <Route path="instagram-automatizaciones" element={<InstagramKeywordsPage />} />
        <Route path="fugas-meta" element={<LeadsRecuperarCampanaPage />} />
        <Route path="trazabilidad-leads" element={<LeadsTracePage />} />
        <Route path="configuracion" element={<ConfigPage />} />
        <Route path="configuracion/reunion" element={<MeetingStagesPage />} />

        <Route path="old" element={<ResumenRoute />} />
        <Route path="old/leads/recuperar-campana" element={<Navigate to="/fugas-meta" replace />} />
        <Route path="old/leads" element={<LeadsRoute />}>
          <Route index element={<LeadsResumenPage />} />
          <Route path="calidad" element={<LeadsCalidadPage />} />
          <Route path="embudo" element={<LeadsEmbudoPage />} />
          <Route path="conversion" element={<LeadsConversionPage />} />
          <Route path="tendencias" element={<LeadsTendenciasPage />} />
          <Route path="distribucion" element={<LeadsDistribucionPage />} />
          <Route path="inventario-kommo" element={<LeadsInventarioPage />} />
        </Route>
        <Route path="old/comercial" element={<ComercialPage />} />
        <Route path="old/marketing" element={<Navigate to="/marketing" replace />} />
        <Route path="old/reuniones" element={<ReunionesPage />} />
        <Route path="old/reservas" element={<ReservasPage />} />
        <Route path="old/proyectos" element={<ProyectosPage />} />
        <Route path="old/ejecutivos" element={<EjecutivosPage />} />

        <Route path="leads/*" element={<LegacyLeadsRedirect />} />
        <Route path="comercial" element={<Navigate to="/old/comercial" replace />} />
        <Route path="reuniones" element={<Navigate to="/old/reuniones" replace />} />
        <Route path="reservas" element={<Navigate to="/old/reservas" replace />} />
        <Route path="proyectos" element={<Navigate to="/old/proyectos" replace />} />
        <Route path="ejecutivos" element={<Navigate to="/old/ejecutivos" replace />} />
        <Route path="dashboard-ejecutivo" element={<Navigate to="/old" replace />} />

        <Route path="lab" element={<LabSection />}>
          <Route index element={<Navigate to="atencion" replace />} />
          <Route path="atencion" element={<LabAtencionPage />} />
          <Route path="tracker" element={<LabTrackerPage />} />
          <Route path="metas" element={<LabMetasPage />} />
          <Route path="definiciones" element={<LabDefinicionesPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
